import { Stack } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryFallback from 'src/sections/error/error-boundary-fallback';
import { AiInterviewState } from './constants/constants-nav';
import {
  CandidateProfileContext,
  CandidateProfileProvider,
} from './context/candidate-profile-context';
import ProfileHeader from './profile-header';
import LeftContainer from './left-container';
import RightContainer from './right-container';
import CandidateProfileLayout from './layout';

const PublicCandidateProfile = ({
  role,
  candidateType,
  candidateId,
  open,
  setOpen,
  jobId,
  currentCandidateIndex,
  totalCandidates,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  onClose: closeHandler,
  layout = 'drawer',
  token,
}) => (
  <ErrorBoundary key={candidateId} FallbackComponent={ErrorBoundaryFallback}>
    <CandidateProfileProvider
      candidateId={candidateId}
      jobId={jobId}
      candidateType={candidateType}
      token={token}
    >
      <CandidateProfileLayout
        onClose={closeHandler}
        open={open}
        layout={layout}
      >
        <ProfileHeader
          totalCandidates={totalCandidates}
          candidateNumber={currentCandidateIndex}
          jobRole={role}
          onClose={closeHandler}
          onPrevious={onPrevious}
          onNext={onNext}
          hasPrevious={hasPrevious}
          hasNext={hasNext}
        />
        <ErrorBoundary
          key={`data-${candidateId}`}
          FallbackComponent={ErrorBoundaryFallback}
        >
          <CandidateProfileContext.Consumer>
            {value => (
              <Stack
                width={{
                  xs: '100%',
                  md: '80%',
                }}
                height="100%"
                mx="auto"
                spacing={{ xs: '24px', md: '28px' }}
              >
                <LeftContainer
                  setNavGroup={value.setNavGroup}
                  jobId={value.jobId}
                  updateCandidateFlag={null}
                />
                <RightContainer
                  navGroup={value.navGroup}
                  setNavGroup={value.setNavGroup}
                  jobId={value.jobId}
                />
              </Stack>
            )}
          </CandidateProfileContext.Consumer>
        </ErrorBoundary>
      </CandidateProfileLayout>
    </CandidateProfileProvider>
  </ErrorBoundary>
);

export default PublicCandidateProfile;

PublicCandidateProfile.propTypes = {
  role: PropTypes.string,
  candidateId: PropTypes.string.isRequired,
  jobId: PropTypes.string,
  open: PropTypes.bool,
  currentCandidateIndex: PropTypes.number,
  totalCandidates: PropTypes.number,
  setOpen: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  hasPrevious: PropTypes.bool,
  hasNext: PropTypes.bool,
  onClose: PropTypes.func,
  layout: PropTypes.oneOf(['full', 'drawer']),
  candidateType: PropTypes.string,
  token: PropTypes.string,
};
